export default {
      id: "star-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#star-usage",
      toString: function () {
        return this.url;
      }
    }